import styles from './LocationAutoCompleteInput.module.css'
import { Options } from './Options'
import classNames from 'classnames'

interface LocationAutoCompleteInputProps{
    value?: any
    text?: any
    options?: any[]
    ref?: any
    isLoading?: boolean
    isOptionsOpen?: boolean
    error: any
    onInput?: (event: any) => void
    onOptionClick?: (event: any) => void
}

export const LocationAutoCompleteInput = (props: LocationAutoCompleteInputProps): JSX.Element => {
    const {
        text = '',
        value,
        options = [],
        ref,
        isLoading = false,
        isOptionsOpen = false,
        error,
        onInput,
        onOptionClick
    } = props

    const handleInputInput = (event: any) => {
        onInput?.(event.target.value)
    }

    const handleOptionsItemClick = (event: any) => {
        onOptionClick?.(event)
    }

    const autocompleteInputClasses = classNames(styles.AutocompleteInput, {
        [styles[`AutocompleteInput--Error`]]: error !== undefined,
    })

    return (
        <div className={autocompleteInputClasses}>
            <div className={styles.AutocompleteInput__InputWrapper}>
                <input 
                    className={styles.AutocompleteInput__Input}
                    ref={ref}
                    value={text}
                    onInput={handleInputInput}
                />
            </div>   
            <Options 
                isLoading={isLoading}
                isOptionsOpen={isOptionsOpen}
                error={error}
                options={options}
                onOptionClick={handleOptionsItemClick}
            />
        </div>
    )
}